import React from 'react';
import PropTypes from 'prop-types';
import SelectBox from '../../SelectBox';
import WizardInput from '../Input';

const CategorySelector = ({ categories, onChange, value, disabled, t, locale, name }) => (
  <WizardInput title={t('course.create.wizard.step2_1')} hint={t('wizard.hint.category')}>
    <SelectBox
      size="large"
      disabled={disabled}
      value={value || t}
      name={name}
      label={t('category')}
      onChange={onChange}
      filterOption={(input, option) =>
        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
      placeholder={t('course.edit.category.placeholder')}
      options={categories.map(option => ({ id: option.id, value: option[`title_${locale}`] }))}
    />
  </WizardInput>
);

CategorySelector.propTypes = {
  disabled: PropTypes.bool,
  categories: PropTypes.array,
  value: PropTypes.string,
  name: PropTypes.string,
  t: PropTypes.func,
  onChange: PropTypes.func,
  locale: PropTypes.string,
};

CategorySelector.defaultProps = {
  disabled: false,
  categories: [],
  value: '',
  name: '',
  t: () => {},
  onChange: () => {},
  locale: '',
};

export default CategorySelector;
